import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/IntegerField/spinner";

export class IntegerFieldspinner extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }

}

export default IntegerFieldspinner;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/IntegerField/spinner.js